<template>
    <div id="profile" class="m-grid__item m-grid__item--fluid m-wrapper">
        <bread-crumb>
            <span slot="title">Profile</span>
            <ul class="m-subheader__BreadCrumbs m-nav m-nav--inline" slot="links">
                <li class="m-nav__item">
                    <router-link :to="{ name: 'profile' }" class="m-nav__link">
                        <span class="m-nav__link-text">
                            Profile
                        </span>
                    </router-link>
                </li>
            </ul>
        </bread-crumb>
        <div class="m-content">
            <div class="row">
                <div class="col-md-7">
                    <div class="m-portlet">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                    <span class="m-portlet__head-icon m--hide">
                                        <i class="la la-gear"></i>
                                    </span>
                                    <h3 class="m-portlet__head-text">
                                        Enter Details
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <profile-details></profile-details>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="m-portlet">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                    <span class="m-portlet__head-icon m--hide">
                                        <i class="la la-gear"></i>
                                    </span>
                                    <h3 class="m-portlet__head-text">
                                        Change Password
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <password></password>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import profileDetails from "./partials/Details";
import password from "./partials/Password";
import breadCrumb from "../../partials/BreadCrumb";
import helpers from "../../../helpers";

export default {
  name: "user-profile",
  components: {
    profileDetails,
    password,
    breadCrumb
  },
  created: function() {
    helpers.resetItems();
  }
};
</script>




// WEBPACK FOOTER //
// src/components/pages/profile/Profile.vue